import { isDefined, isObject } from 'ionic-angular/util/util';
import { BaseObject } from '../business-objects/base-object/base-object.model';
import { ENTITY_MAP } from '../../app/app.config.entity-map';

/**
 * Returns a new instance of an entity
 * @param entity string the name of the entity
 * @param data object optional data to initialise the entity
 */
export const entityFactory = (entity: string, data?: object): BaseObject => {

    if (!isDefined(ENTITY_MAP[entity])) {
        throw Error(`entity ${entity} not found`);
    }

    const f = ENTITY_MAP[entity];

    if (isObject(f)) {
        return f.factory(data);
    }

    return new f(data);
};



// WEBPACK FOOTER //
// ./src/core/helpers/entity-factory.ts